import { ReactComponent as CloseIcon } from 'assets/close.svg';
import styled, { useTheme } from 'styled-components';

const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1000;
`;

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
`;

const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 32px;
  border-radius: 16px;
  max-width: 90vw;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  position: absolute;
  top: 12px;
  right: 8px;
`;

interface Props {
  isOpen: boolean;
  onClose?: () => void;
}

export const Modal: React.FC<React.PropsWithChildren<Props>> = ({
  isOpen,
  onClose,
  children,
}) => {
  const theme = useTheme();

  if (!isOpen) {
    return null;
  }

  return (
    <Container>
      <Overlay onClick={onClose} />
      <ModalContainer>
        {onClose && (
          <CloseButton onClick={onClose}>
            <CloseIcon color={theme.palette.dark[800]} />
          </CloseButton>
        )}
        {children}
      </ModalContainer>
    </Container>
  );
};
